// extracted by mini-css-extract-plugin
export default {"container":"orderAddress_container__o+pkd","image":"orderAddress_image__IQ-Yw"};